import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import LoadingSpinner from '../components/ui/LoadingSpinner';

const Login = React.lazy(() => import('../pages/auth/Login'));
const Register = React.lazy(() => import('../pages/auth/Register'));
const ForgotPassword = React.lazy(() => import('../pages/auth/ForgotPassword'));
const ResetPassword = React.lazy(() => import('../pages/auth/ResetPassword'));
const ProfileSetup = React.lazy(() => import('../pages/auth/ProfileSetup'));
const UserPreferences = React.lazy(() => import('../pages/auth/UserPreferences'));
const EmailVerification = React.lazy(() => import('../pages/auth/EmailVerification'));
const EmailVerificationSuccess = React.lazy(() => import('../pages/auth/EmailVerificationSuccess'));
const SocialLoginValidation = React.lazy(() => import('../pages/auth/SocialLoginValidation'));
const SocialLoginError = React.lazy(() => import('../pages/auth/SocialLoginError'));
const ResetPasswordSent = React.lazy(() => import('../pages/auth/ResetPasswordSent'));
const PasswordResetSuccess = React.lazy(() => import('../pages/auth/PasswordResetSuccess'));
const TwoFactorEmail = React.lazy(() => import('../pages/auth/TwoFactorEmail'));
const TwoFactorPhone = React.lazy(() => import('../pages/auth/TwoFactorPhone'));
const TwoFactorCode = React.lazy(() => import('../pages/auth/TwoFactorCode'));
const TwoFactorSuccess = React.lazy(() => import('../pages/auth/TwoFactorSuccess'));
const SocialAccountCallback = React.lazy(() => import('../pages/auth/SocialAccountCallback'));

const SuspenseWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Suspense fallback={<div className="flex justify-center items-center min-h-screen"><LoadingSpinner size="lg" color="orange" /></div>}>
    {children}
  </Suspense>
);

export const guestAuthRoutes = (
  <>
    <Route path="/login" element={<SuspenseWrapper><Login /></SuspenseWrapper>} />
    <Route path="/register" element={<SuspenseWrapper><Register /></SuspenseWrapper>} />
    <Route path="/forgot-password" element={<SuspenseWrapper><ForgotPassword /></SuspenseWrapper>} />
    <Route path="/reset-password" element={<SuspenseWrapper><ResetPassword /></SuspenseWrapper>} />
  </>
);

export const hybridAuthRoutes = (
  <>
    <Route path="/profile-setup" element={<SuspenseWrapper><ProfileSetup /></SuspenseWrapper>} />
    <Route path="/user-preferences" element={<SuspenseWrapper><UserPreferences /></SuspenseWrapper>} />
    <Route path="/verify-email" element={<SuspenseWrapper><EmailVerification /></SuspenseWrapper>} />
    <Route path="/email-verification-success" element={<SuspenseWrapper><EmailVerificationSuccess /></SuspenseWrapper>} />
    <Route path="/social-login-validation" element={<SuspenseWrapper><SocialLoginValidation /></SuspenseWrapper>} />
    <Route path="/social-login-error" element={<SuspenseWrapper><SocialLoginError /></SuspenseWrapper>} />
    <Route path="/reset-password-sent" element={<SuspenseWrapper><ResetPasswordSent /></SuspenseWrapper>} />
    <Route path="/password-reset-success" element={<SuspenseWrapper><PasswordResetSuccess /></SuspenseWrapper>} />
    <Route path="/two-factor-email" element={<SuspenseWrapper><TwoFactorEmail /></SuspenseWrapper>} />
    <Route path="/two-factor-phone" element={<SuspenseWrapper><TwoFactorPhone /></SuspenseWrapper>} />
    <Route path="/two-factor-code" element={<SuspenseWrapper><TwoFactorCode /></SuspenseWrapper>} />
    <Route path="/two-factor-success" element={<SuspenseWrapper><TwoFactorSuccess /></SuspenseWrapper>} />
    <Route path="/social-account-callback" element={<SuspenseWrapper><SocialAccountCallback /></SuspenseWrapper>} />
  </>
);
